// Parse a date-only value locally, avoiding UTC offsets on Brazilian birthdays.
export function personAgeParts(value, today = new Date()) {
  const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})(?:$|T)/);
  if (!match) return null;
  const [year, month, day] = match.slice(1).map(Number);
  const birth = new Date(year, month - 1, day);
  if (birth.getFullYear() !== year || birth.getMonth() !== month - 1 || birth.getDate() !== day || birth > today) return null;
  let months = (today.getFullYear() - year) * 12 + today.getMonth() - (month - 1);
  if (today.getDate() < day) months -= 1;
  return { years: Math.floor(months / 12), months: months % 12 };
}
export function formatPersonAge(value, today = new Date()) {
  const age = personAgeParts(value, today);
  if (!age) return '';
  return `${age.years} ${age.years === 1 ? 'ano' : 'anos'} e ${age.months} ${age.months === 1 ? 'mês' : 'meses'}`;
}
